import {
  BrightyListItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ErrorListItem,
  List,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';
import { ApiPayout } from '../../../openapi';
import { useCancelPayoutMutation } from '../../../api/payouts';
import { useIdempotencyKey } from '../../../hooks/useIdempotencyKey';

export function AbortPayoutDialog({
  payout,
  onClose,
}: {
  payout: ApiPayout | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const idempotencyKey = useIdempotencyKey();
  const mutation = useCancelPayoutMutation({
    idempotencyKey,
  });

  const handleSubmit = useCallback(() => {
    if (payout) {
      mutation.mutate({ payoutId: payout.id, createdAt: payout.createdAt });
    }
  }, [payout, mutation]);

  useEffect(() => {
    if (mutation.isSuccess) {
      onClose();
      mutation.reset();
    }
  }, [mutation, onClose]);

  return (
    <Dialog open={Boolean(payout)} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>{t('Are you sure you want to cancel this payout?')}</DialogTitle>
      <DialogContent>
        <List>
          <BrightyListItem title={payout?.name} />
          {mutation.error ? <ErrorListItem error={mutation.error} /> : null}
        </List>
      </DialogContent>
      <DialogActions>
        <Button autoFocus color="secondary" onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button color="error" loading={mutation.isPending} onClick={handleSubmit}>
          {t('Abort')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
